// extracted by mini-css-extract-plugin
export default {"subheader":"Subheader_subheader__-xTyr"};